import { Typography } from '@tempmee/react';
import { Box, Row } from '~/commonComponents';

interface ITitleProps {
  color: string;
  title: string;
  count?: number;
}

export const Title = ({ color, count = 0, title }: ITitleProps) => (
  <Row alignItems="stretch">
    <Box backgroundColor={color} borderRadius={4} marginRight={8} width={4} />
    <Typography as="span" bold size="body_large">
      {title} ({count}):
    </Typography>
  </Row>
);
